import React from 'react';
import ComingSoon from 'assets/img/coming-soon.svg';

export default function DashboardContainer() {
  return (
    <div className="d-flex w-100 justify-content-center h-100 align-items-center">
      <p
        style={{
          textAlign: 'center',
          paddingTop: '120px',
          fontSize: '30px',
          fontWeight: 'bold',
        }}
      >
        <img
          style={{ width: '200px', height: '200px' }}
          src={ComingSoon}
          alt=""
        />
      </p>
    </div>
  );
}